const REQUESTED = 'pending';
const COOKING = 'making';
const READY = 'readyToDeliver';
const DELIVERED = 'delivered';
const ASSIGNED = 'assigned';
const ON_THE_WAY = 'ontheway';
const CANCELED = 'canceled';
const TAKEAWAY_TYPE = 'takeAway';
const DELIVERY_TYPE = 'delivery';
const TABLE_TYPE = 'table'

/*
export default {
  REQUESTED : 'pending'
, COOKING : 'making'
, READY : 'readyToDeliver'
, DELIVERED : 'delivered'
, ASSIGNED : 'assigned'
, ON_THE_WAY : 'ontheway'
, CANCELED : 'canceled'
, TAKEAWAY_TYPE : 'takeAway'
, DELIVERY_TYPE : 'delivery'
, TABLE_TYPE : 'table'
}
*/

export { 
  REQUESTED
, COOKING 
, READY 
, DELIVERED
, ASSIGNED 
, ON_THE_WAY 
, CANCELED 
, TAKEAWAY_TYPE
, DELIVERY_TYPE
, TABLE_TYPE
}


// WEBPACK FOOTER //
// ./src/common/Constants.js